import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class depotsTableCtrl implements IController {

  branchIds: any;
  queryString: any;
  canRemove: any;
  enableDefault: any;
  defaultId: any;
  depotIds: any;
  doReload: any;
  onReload: Function;
  onRemove: Function;
  onSelect: Function;
  onDefault: Function;

  private depotsRef: any;
  private loadLimit: any;

  public infiniteScroll: any;
  public isScrollable: boolean;

  /* @ngInject */
  constructor(private $depots, private $infiniteScroll, private $log, private $mdMedia) {
    this.depotsRef = this.$depots();
  }

  $onInit() {
    this.loadLimit = 30;
    this.depotsRef.$query(this._getDepotsQuery());
    this.infiniteScroll = this.$infiniteScroll(this.depotsRef, this.loadLimit);
  }

  $doCheck() {
    this.isScrollable = !this.$mdMedia('gt-sm');
  };

  $onChanges(changes) {
    if (changes.doReload && !changes.doReload.isFirstChange()) {
      if (this.doReload) {
        this._loadDepots();
      }
    }

    if (changes.depotIds && !changes.depotIds.isFirstChange()) {
      this._loadDepots();
    }
  };

  onClick(depot) {
    if (this.onSelect && _.isFunction(this.onSelect)) {
      this.onSelect({depot: depot});
    }
  }

  onDefaultSelect(id) {
    this.onDefault({id: id})
  }

  // ******************************
  //        Private methods
  // ******************************

  private _loadDepots() {
    this.depotsRef.$query(this._getDepotsQuery())
      .then(() => {
        this.infiniteScroll.reload();
        this.onReload();
      })
      .catch((error) => {
        this.$log.error('Failed to load depots @depotsTable@_loadDepots', error)
      })
  }

  private _getDepotsQuery() {
    return {
      ids: this.depotIds,
      query: this.queryString,
      branchIds: this.branchIds,
      limit: this.loadLimit
    }
  }


}

angular
  .module('bringoz.admin.depots')
  .component('depotsTable', {
    bindings: {
      branchIds: '<?',
      queryString: '<?',
      canRemove: '<',
      enableDefault: '<?',
      defaultId: '<?',
      depotIds: '<?',
      doReload: '<',
      onReload: '&',
      onRemove: '&',
      onSelect: '&?',
      onDefault: '&?'
    },
    template: require('./depots-table.html').default,
    controller: depotsTableCtrl
  });
